import { normalizeForSearch } from './textSanitize';

/** @deprecated Preferir normalizeForSearch de textSanitize.js */
export function normalizarTextoMp(s) {
  return normalizeForSearch(s);
}

function levenshtein(a, b) {
  const m = a.length;
  const n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = 0; i <= m; i++) dp[i][0] = i;
  for (let j = 0; j <= n; j++) dp[0][j] = j;
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
    }
  }
  return dp[m][n];
}

/** Score 0–1 entre descrição digitada e um texto (nome ou sinônimo). */
export function scoreSimilaridadeMp(descricao, textoCadastrado) {
  const q = normalizarTextoMp(descricao);
  const n = normalizarTextoMp(textoCadastrado);
  if (!q.length || !n.length) return 0;
  if (n.includes(q) || q.includes(n)) return 0.92;
  const dist = levenshtein(q, n);
  const maxLen = Math.max(q.length, n.length);
  const ratioLev = 1 - dist / maxLen;
  const tokensQ = q.split(/\s+/).filter((t) => t.length > 2);
  const tokensN = new Set(n.split(/\s+/));
  let overlap = 0;
  for (const t of tokensQ) {
    if (tokensN.has(t) || [...tokensN].some((tn) => tn.includes(t) || t.includes(tn))) overlap++;
  }
  const ratioTok = tokensQ.length ? overlap / tokensQ.length : 0;
  return Math.max(ratioLev * 0.85 + ratioTok * 0.15, ratioTok * 0.7);
}

/** Nome + sinônimos de um insumo para busca. */
export function getTextosBuscaInsumo(produto) {
  const textos = [];
  const nome = produto?.nome || produto?.nome_produto || '';
  if (nome) textos.push(String(nome));
  const sins = produto?.sinonimos;
  if (Array.isArray(sins)) {
    for (const s of sins) {
      if (s != null && String(s).trim()) textos.push(String(s).trim());
    }
  }
  return textos;
}

/** Melhor score entre nome e sinônimos; indica qual texto deu match. */
export function scoreSimilaridadeInsumo(descricao, produto) {
  let best = 0;
  let matchTexto = '';
  for (const t of getTextosBuscaInsumo(produto)) {
    const sc = scoreSimilaridadeMp(descricao, t);
    if (sc > best) {
      best = sc;
      matchTexto = t;
    }
  }
  return { score: best, matchTexto };
}

/** Filtro de lista (picker): termo em nome, código, subcategoria ou sinônimos. */
export function insumoCorrespondeTermo(produto, termoRaw, { getNome, getCodigo } = {}) {
  const term = normalizarTextoMp(termoRaw);
  if (!term) return true;

  const nomeFn = getNome || ((p) => p?.nome || p?.nome_produto || '');
  const codFn = getCodigo || ((p) => p?.codigo || p?.codigo_produto || p?.codigo_origem || '');

  const campos = [
    nomeFn(produto),
    codFn(produto),
    produto?.subcategoria || '',
    ...getTextosBuscaInsumo(produto),
  ];

  return campos.some((c) => normalizarTextoMp(String(c || '')).includes(term));
}
